import '../../../src/main.css';
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import CategoryFilter from '../my_tickets/CategoryFilter';
import SubCategoryFilter from '../my_tickets/SubCategoryFilter';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { Input } from 'antd';
import _ from 'lodash';
const { RangePicker } = DatePicker;
const { Search } = Input;

function FailedTicketFilter({
	selectedCategory,
	selectedSubCategory,
	setSelectedCategory,
	setSelectedSubCategory,
	handleFilterClick,
	handleSearch,
	setStartDateFilter,
	setEndDateFilter,
}) {
	const handleClickFilter = () => {
		handleFilterClick();
		setShow(false);
	};
	const onRangeChange = (dates, dateStrings) => {
		const startDate = dayjs(_.get(dates, [0]))
			.startOf('day')
			.format('YYYY-MM-DD HH:mm:ss');
		const endDate = dayjs(_.get(dates, [1]))
			.endOf('day')
			.format('YYYY-MM-DD HH:mm:ss');
		setStartDateFilter(startDate);
		setEndDateFilter(endDate);
	};
	const rangePresets = [
		{
			label: 'Last 24 Hours',
			value: [dayjs().subtract(1, 'day'), dayjs()],
		},
		{
			label: 'Last 7 Days',
			value: [dayjs().subtract(7, 'day'), dayjs()],
		},
		{
			label: 'Last 14 Days',
			value: [dayjs().subtract(14, 'day'), dayjs()],
		},
		{
			label: 'Last 30 Days',
			value: [dayjs().subtract(30, 'day'), dayjs()],
		},
	];

	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	return (
		<>
			<div className='d-flex justify-content-end gap-2 w-50 float-end my-3'>
				<Search
                    style={{width:'75%'}}
					addonBefore='Search'
					placeholder='Search orders by order Id/email /phone number'
					onSearch={handleSearch}
					allowClear
				/>
				<Button
					onClick={handleShow}
					className='flex-fill'>
					+ More Filter
				</Button>
			</div>
			<Offcanvas
				show={show}
				style={{ width: '35vw' }}
				onHide={handleClose}
				name={'Filter & Download'}
				placement={'end'}>
				<Offcanvas.Header closeButton>
					<Offcanvas.Title>
						<h2>Filter By</h2>
					</Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body >
					<div className='d-flex flex-column align-items-center gap-2'>
						<RangePicker
							style={{ width: '100%' }}
							defaultValue={[dayjs().subtract(1, 'day'), dayjs()]}
							presets={rangePresets}
							onChange={onRangeChange}
							allowEmpty={[false, true]}
							minDate={dayjs().subtract(1, 'month')}
							maxDate={dayjs()}
						/>
						<CategoryFilter
							selectedCategory={selectedCategory}
							setSelectedCategory={setSelectedCategory}
						/>
						<SubCategoryFilter
							selectedCategory={selectedCategory}
							selectedSubCategory={selectedSubCategory}
							setSelectedSubCategory={setSelectedSubCategory}
						/>
						<Button
							variant='primary'
							style={{ width: '100%' }}
							onClick={handleClickFilter}>
							Filter
						</Button>
					</div>
				</Offcanvas.Body>
			</Offcanvas>
		</>
	);
}

export default FailedTicketFilter;
